import React from 'react';
import { observer } from 'mobx-react';
import { EvaluateButtonsWrapper } from '@seedlang/hoc';
import { DeckUI } from '@seedlang/state';
import { BigSmileFaceIcon, NeutralFaceIcon, SmileFaceIcon } from '@seedlang/icons';
import CardButtons from 'components/card/card_buttons';
import CardButton from 'components/card/card_button';
import NextButton from 'components/button/next_button';

@observer
class EvaluateButtons extends React.Component {

  getIcon(iconType) {
    switch (iconType) {
      case 'neutral':
        return <NeutralFaceIcon />;
      case 'smile':
        return <SmileFaceIcon />;
      case 'bigSmile':
        return <BigSmileFaceIcon />;
      default:
        return null;
    }
  }

  render() {
    if (!DeckUI.reviewDeck) {
      return (
        <CardButtons>
          <NextButton
            disabled={this.props.disabled}
            onClick={this.props.onNextClick}
            submitOnEnter
            shortcut='1'
          />
        </CardButtons>
      );
    }

    return (
      <CardButtons>
        {
        this.props.buttons.map(button => {
          return (
            <CardButton
              key={button.id}
              shortcut={button.shortcut}
              text={button.text}
              backgroundColor={button.backgroundColor}
              icon={this.getIcon(button.iconType)}
              onClick={() => this.props.advanceCard(
                this.props.card,
                this.props.cardState,
                this.props.userCard,
                {
                  score: button.score,
                  skipSoundEffect: button.skipSoundEffect,
                  xp: button.xp,
                  xpXPos: button.xpXPos,
                },
              )}
              subText={button.subText}
              disabled={button.disabled}
              marginRight={button.marginRight}
              marginLeft={button.marginLeft}
            />
          );
        })}
      </CardButtons>
    );
  }
}

export default EvaluateButtonsWrapper(EvaluateButtons);
